import { Grid, Typography } from "@mui/material"
import { useMemo, useState } from "react"
import DetalhesFiltros from "../../../../MIContaCorrenteConsumo/VisaoGeral/DialogDetalheFechamento/FiltrosAplicadosFechamento/DetalhesFiltros";
import { TCCOConfiguracoesFiltros } from "../../../../../../../types/api/financeiro/conta-corrente-consumo-configuracoes";
import TiposPublicos from "../../../../MIContaCorrenteConsumo/VisaoGeral/DialogDetalheFechamento/FiltrosAplicadosFechamento/FiltrosModais/TiposPublicos";
import CodigosPublicos from "../../../../MIContaCorrenteConsumo/VisaoGeral/DialogDetalheFechamento/FiltrosAplicadosFechamento/FiltrosModais/CodigosPublicos";
import DetalhesPublicos from "../../../../MIContaCorrenteConsumo/VisaoGeral/DialogDetalheFechamento/FiltrosAplicadosFechamento/FiltrosModais/DetalhesPublicos";
import { useFormContext } from "react-hook-form";
import TitReceberAberto from "../../../../MIContaCorrenteConsumo/VisaoGeral/DialogDetalheFechamento/FiltrosAplicadosFechamento/FiltrosModais/TitReceberAberto";
import { verificarDataLabel } from "../../../../../../../helpers/verificarDataLabel";
import ChipWithDialogTableSimples from "../../../../../../../components/ChipWithDialogTableSimples";
import TitPagarAberto
    from "../../../../MIContaCorrenteConsumo/VisaoGeral/DialogDetalheFechamento/FiltrosAplicadosFechamento/FiltrosModais/TitPagarAberto";

export default function CCOFiltrosConfig() {

    const { setValue, watch } = useFormContext()

    const filtrosParams: TCCOConfiguracoesFiltros | null = watch('filtros')

    const [openFiltros, setOpenFiltros] = useState<TOpenFiltros>({
        tipoPublico: false,
        codigoPublico: false,
        detalhePublico: false,
        periodoApuracao: false,
        titReceberAberto: false,
        titPagarAberto: false
    });
    //Funções manipuladoras
    const handleClickOpenFiltros = (key: keyof TOpenFiltros) => {
        setOpenFiltros(prevState => ({ ...prevState, [key]: !prevState[key] }))
    };
    //

    //Valores importantes
    const codigosPublicos = useMemo(() => {
        const defaultValue = filtrosParams?.codigos_publicos
        const value = typeof defaultValue === "object" && "apenas_os_codigos" in defaultValue && defaultValue.apenas_os_codigos.length > 0
            ? `Apenas: ${defaultValue.apenas_os_codigos.join(', ')}`
            : typeof defaultValue === "object" && "exceto_os_codigos" in defaultValue && defaultValue.exceto_os_codigos.length > 0
                ? `Exceto: ${defaultValue.exceto_os_codigos.join(', ')}`
                : "Todos";
        return value
    }, [filtrosParams?.codigos_publicos])

    const formatarTituloReceber = useMemo(() => {
        const titulo_receber_aberto = {
            periodo_emissao_inicio: filtrosParams?.titulo_receber_emissao_inicio ?? null,
            periodo_emissao_fim: filtrosParams?.titulo_receber_emissao_fim ?? null,
            periodo_vencimento_inicio: filtrosParams?.titulo_receber_vencimento_inicio ?? null,
            periodo_vencimento_fim: filtrosParams?.titulo_receber_vencimento_fim ?? null,
            funcao: filtrosParams?.titulo_receber_funcao ?? null,
            situacao: filtrosParams?.titulo_receber_situacao ?? null,
            tipo_documento: filtrosParams?.titulo_receber_tipo_documento ?? null,
            considera_titulos: filtrosParams?.titulo_receber_considera_titulos ?? null
        }
        return titulo_receber_aberto
    }, [filtrosParams?.titulo_receber_emissao_inicio, filtrosParams?.titulo_receber_emissao_fim, filtrosParams?.titulo_receber_vencimento_inicio,
    filtrosParams?.titulo_receber_vencimento_fim, filtrosParams?.titulo_receber_funcao, filtrosParams?.titulo_receber_considera_titulos, filtrosParams?.titulo_receber_situacao, filtrosParams?.titulo_receber_tipo_documento])

    const titReceberEmissaoLabel = useMemo(() => {
        return verificarDataLabel(filtrosParams?.titulo_receber_emissao_inicio, filtrosParams?.titulo_receber_emissao_fim)
    }, [filtrosParams?.titulo_receber_emissao_inicio, filtrosParams?.titulo_receber_emissao_fim])

    const titReceberVencimentoLabel = useMemo(() => {
        return verificarDataLabel(filtrosParams?.titulo_receber_vencimento_inicio, filtrosParams?.titulo_receber_vencimento_fim)
    }, [filtrosParams?.titulo_receber_vencimento_inicio, filtrosParams?.titulo_receber_vencimento_fim])

    const verificarFiltrosReceber = useMemo(() => {
        return titReceberEmissaoLabel === "Todos" && titReceberVencimentoLabel === "Todos" && !filtrosParams?.titulo_receber_funcao
    }, [titReceberEmissaoLabel, titReceberVencimentoLabel, filtrosParams?.titulo_receber_funcao])

    const titPagarEmissaoLabel = useMemo(() => {
        return verificarDataLabel(filtrosParams?.titulo_pagar_emissao_inicio, filtrosParams?.titulo_pagar_emissao_fim)
    }, [filtrosParams?.titulo_pagar_emissao_inicio, filtrosParams?.titulo_pagar_emissao_fim])

    const titPagarVencimentoLabel = useMemo(() => {
        return verificarDataLabel(filtrosParams?.titulo_pagar_vencimento_inicio, filtrosParams?.titulo_pagar_vencimento_fim)
    }, [filtrosParams?.titulo_pagar_vencimento_inicio, filtrosParams?.titulo_pagar_vencimento_fim])
    //

    return (
        <>
            <Typography mt={2}><b>Filtros da configuração</b></Typography>
            <Grid container spacing={1}>
                <Grid size={{xs: 6, sm: 4, md: 4}}>
                    <DetalhesFiltros
                        isEdit
                        gap={1}
                        label="Tipos público"
                        value={filtrosParams?.tipos_publicos && filtrosParams.tipos_publicos.length > 0 ? filtrosParams?.tipos_publicos.join(', ') : "Todos"}
                        action={() => { handleClickOpenFiltros('tipoPublico') }}
                    />
                </Grid>
                <Grid size={{xs: 6, sm: 4, md: 4}}>
                    <DetalhesFiltros
                        isEdit
                        gap={1}
                        label="Códigos público"
                        value={codigosPublicos}
                        action={() => { handleClickOpenFiltros('codigoPublico') }}
                    />
                </Grid>
                <Grid size={{xs: 6, sm: 4, md: 4}}>
                    <DetalhesFiltros
                        isEdit
                        gap={1}
                        label="Detalhes do público"
                        value={filtrosParams?.detalhe_publico ?? 'Todos'}
                        action={() => { handleClickOpenFiltros('detalhePublico') }}
                    />
                </Grid>
                <Grid size={{xs: 6, sm: 4, md: 4}}>
                    <DetalhesFiltros
                        isEdit
                        gap={1}
                        label="Títulos a receber em aberto"
                        value={
                            <>
                                {
                                    filtrosParams?.titulo_receber_considera_titulos === "Não" &&
                                    <span>Nenhum</span>
                                }{
                                    (filtrosParams?.titulo_receber_considera_titulos === "Sim" || !filtrosParams?.titulo_receber_considera_titulos) &&
                                    <>
                                        {
                                            verificarFiltrosReceber &&
                                            <span>
                                                Todos
                                            </span>
                                        }
                                        {
                                            !verificarFiltrosReceber &&
                                            <>
                                                <span>
                                                    Emissão: {titReceberEmissaoLabel}
                                                </span>
                                                <br />
                                                <span>
                                                    Vencimento: {titReceberVencimentoLabel}
                                                </span>
                                                <br />
                                                {
                                                    !filtrosParams?.titulo_receber_funcao &&
                                                    <span>
                                                        Função: Todas consideradas
                                                    </span>
                                                }
                                                {
                                                    filtrosParams?.titulo_receber_funcao &&
                                                    <span>
                                                        Função:  {
                                                            filtrosParams?.titulo_receber_funcao.length <= 0 ? "-" :
                                                                `${filtrosParams?.titulo_receber_funcao.slice(0, 3).map(item => item.id).join(', ')} `
                                                        }
                                                        {
                                                            filtrosParams?.titulo_receber_funcao.length > 3 &&
                                                            <ChipWithDialogTableSimples
                                                                chipCount={`+${filtrosParams?.titulo_receber_funcao.length - 3}`}
                                                                dialogTitle="Funções"
                                                                headers={[
                                                                    { label: "Id" },
                                                                    { label: "Nome" }
                                                                ]}
                                                                rows={filtrosParams?.titulo_receber_funcao.map(row => ({
                                                                    columns: [
                                                                        { value: row.id },
                                                                        { value: row.nome }
                                                                    ]
                                                                }))}
                                                                maxHeight={600}
                                                            />
                                                        }
                                                    </span>
                                                }
                                                <br />
                                                {
                                                    !filtrosParams?.titulo_receber_tipo_documento &&
                                                    <span>
                                                        Tipo documento: Todos considerados
                                                    </span>
                                                }
                                                {
                                                    filtrosParams?.titulo_receber_tipo_documento &&
                                                    <span>
                                                        Tipo documento:  {
                                                            filtrosParams?.titulo_receber_tipo_documento.length <= 0 ? "-" :
                                                                `${filtrosParams?.titulo_receber_tipo_documento.slice(0, 3).map(item => item.id).join(', ')} `
                                                        }
                                                        {
                                                            filtrosParams?.titulo_receber_tipo_documento.length > 3 &&
                                                            <>
                                                                <ChipWithDialogTableSimples
                                                                    chipCount={`+${filtrosParams?.titulo_receber_tipo_documento.length - 3}`}
                                                                    dialogTitle="Tipos documento"
                                                                    headers={[
                                                                        { label: "Id" },
                                                                        { label: "Nome" }
                                                                    ]}
                                                                    rows={filtrosParams?.titulo_receber_tipo_documento.map(row => ({
                                                                        columns: [
                                                                            { value: row.id },
                                                                            { value: row.nome }
                                                                        ]
                                                                    }))}
                                                                    maxHeight={600}
                                                                />
                                                            </>
                                                        }
                                                    </span>
                                                }
                                                <br />
                                                {
                                                    !filtrosParams?.titulo_receber_situacao &&
                                                    <span>
                                                        Situação: Todas consideradas
                                                    </span>
                                                }
                                                {
                                                    filtrosParams?.titulo_receber_situacao &&
                                                    <span>
                                                        Situação:  {
                                                            filtrosParams?.titulo_receber_situacao.length <= 0 ? "-" :
                                                                `${filtrosParams?.titulo_receber_situacao.slice(0, 3).map(item => item.id).join(', ')} `
                                                        }
                                                        {
                                                            filtrosParams?.titulo_receber_situacao.length > 3 &&
                                                            <ChipWithDialogTableSimples
                                                                chipCount={`+${filtrosParams?.titulo_receber_situacao.length - 3}`}
                                                                dialogTitle="Situações"
                                                                headers={[
                                                                    { label: "Id" },
                                                                    { label: "Nome" }
                                                                ]}
                                                                rows={filtrosParams?.titulo_receber_situacao.map(row => ({
                                                                    columns: [
                                                                        { value: row.id },
                                                                        { value: row.nome }
                                                                    ]
                                                                }))}
                                                                maxHeight={600}
                                                            />
                                                        }
                                                    </span>
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </>
                        }
                        action={() => { handleClickOpenFiltros('titReceberAberto') }}
                    />
                </Grid>
                <Grid size={{xs: 6, sm: 4, md: 4}}>
                    <DetalhesFiltros
                        isEdit
                        gap={1}
                        label="Títulos a pagar em aberto"
                        value={
                            <>
                                {
                                    filtrosParams?.titulo_pagar_considera_titulos === "Não" &&
                                    <span>Nenhum</span>
                                }{
                                (filtrosParams?.titulo_pagar_considera_titulos === "Sim" || !filtrosParams?.titulo_pagar_considera_titulos) &&
                                <>
                                    {
                                        verificarFiltrosReceber &&
                                        <span>
                                                Todos
                                            </span>
                                    }
                                    {
                                        !verificarFiltrosReceber &&
                                        <>
                                                <span>
                                                    Emissão: {titPagarEmissaoLabel}
                                                </span>
                                            <br />
                                            <span>
                                                    Vencimento: {titPagarVencimentoLabel}
                                                </span>
                                            <br />
                                        </>
                                    }
                                </>
                            }
                            </>
                        }
                        action={() => { handleClickOpenFiltros('titPagarAberto') }}
                    />
                </Grid>

            </Grid>

            {
                openFiltros.tipoPublico &&
                <TiposPublicos
                    open={openFiltros.tipoPublico}
                    defaultValue={filtrosParams?.tipos_publicos ?? []}
                    onSubmitFiltros={(value: any) => setValue('filtros.tipos_publicos', value)}
                    onClose={() => handleClickOpenFiltros('tipoPublico')}
                />
            }
            {
                openFiltros.codigoPublico &&
                <CodigosPublicos
                    open={openFiltros.codigoPublico}
                    defaultValue={filtrosParams?.codigos_publicos ?? 'Todos'}
                    onSubmitFiltros={(value: any) => setValue('filtros.codigos_publicos', value)}
                    onClose={() => handleClickOpenFiltros('codigoPublico')}
                />
            }
            {
                openFiltros.detalhePublico &&
                <DetalhesPublicos
                    open={openFiltros.detalhePublico}
                    defaultValue={filtrosParams?.detalhe_publico ?? "Todos"}
                    onSubmitFiltros={(value: any) => setValue('filtros.detalhe_publico', value)}
                    onClose={() => handleClickOpenFiltros('detalhePublico')}
                />
            }
            {
                openFiltros.titReceberAberto &&
                <TitReceberAberto
                    open={openFiltros.titReceberAberto}
                    defaultValue={formatarTituloReceber}
                    onSubmitFiltros={(value: any) => {
                        setValue('filtros.titulo_receber_emissao_inicio', value.periodo_emissao_inicio)
                        setValue('filtros.titulo_receber_emissao_fim', value.periodo_emissao_fim)
                        setValue('filtros.titulo_receber_vencimento_inicio', value.periodo_vencimento_inicio)
                        setValue('filtros.titulo_receber_vencimento_fim', value.periodo_vencimento_fim)
                        setValue('filtros.titulo_receber_considera_titulos', value.considera_titulos)
                        setValue('filtros.titulo_receber_funcao', value.funcao)
                        setValue('filtros.titulo_receber_tipo_documento', value.tipo_documento)
                        setValue('filtros.titulo_receber_situacao', value.situacao)
                    }}
                    onClose={() => handleClickOpenFiltros('titReceberAberto')}
                />
            }
            {
                openFiltros.titPagarAberto &&
                <TitPagarAberto
                    open={openFiltros.titPagarAberto}
                    defaultValue={formatarTituloReceber}
                    onSubmitFiltros={(value: any) => {
                        setValue('filtros.titulo_pagar_emissao_inicio', value.periodo_emissao_inicio)
                        setValue('filtros.titulo_pagar_emissao_fim', value.periodo_emissao_fim)
                        setValue('filtros.titulo_pagar_vencimento_inicio', value.periodo_vencimento_inicio)
                        setValue('filtros.titulo_pagar_vencimento_fim', value.periodo_vencimento_fim)
                        setValue('filtros.titulo_pagar_considera_titulos', value.considera_titulos)
                    }}
                    onClose={() => handleClickOpenFiltros('titPagarAberto')}
                />
            }
        </>
    )
}

type TOpenFiltros = {
    tipoPublico: boolean,
    codigoPublico: boolean,
    detalhePublico: boolean,
    periodoApuracao: boolean,
    titReceberAberto: boolean,
    titPagarAberto: boolean
}
